module.exports = {
    path: '/life-cost',
    component: () => import('@lcc/LifeCost'),
    meta: { module: 'lcc' },
    children: [
        {
            path: 'login',
            component: () => import('@lcc/components/Login')
        },
        {
            path: '',
            component: () => import('@lcc/components/ProjectProperties')
        },
        {
            path: 'projects/:projectId',
            component: () => import('@lcc/components/Home'),
            name: 'lcc_project'
        },
        {
            path: '/projects/:projectId/components',
            component: () => import('@lcc/components/ComponentCatalog'),
            name: 'lcc_components_list'
        },
        {
            path: 'projects/:projectId/analyses/new',
            component: () => import('@lcc/components/AnalysisNew')
        },
        {
            path: 'projects/:projectId/analyses/:analysisId',
            component: () => import('@lcc/components/ComparisonResults'),
            name: 'lcc_analysis'
        },
        {
            path: 'projects/:projectId/analyses',
            component: () => import('@lcc/components/AnalysisPage'),
            name: 'lcc_analyses_list'
        }
        /*
        {
            path: "projects/:projectId/properties",
            component: () => import("@lcc/components/ProjectProperties"),
            name: 'lcc_project_properties',
        },
        */
    ]
};



// WEBPACK FOOTER //
// ./src/modules/life-cost/router.js